// Initialize here
const platForm = new window.H.service.Platform({
	apikey: process.env.VUE_APP_HERE_MAP_API_KEY || "",
});
export default platForm;
